import { LoadingButton } from "@mui/lab";
import { Button, Grid, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { FileSection, FormDatePicker } from "components/atoms";
import { CommonModal } from "components/molecules";
import { FormikHelpers, FormikProvider, useFormik } from "formik";
import { TimeHelper } from "helpers";
import { isUndefined } from "lodash";
import moment, { Moment } from "moment";
import React, { Fragment, useEffect } from "react";
import { PrintActions, ProductionPlanActions } from "redux/actions";
import {
  useAppDispatch,
  useAppSelector,
} from "redux/configurations/reduxHooks";
import { I18nTranslator, translations } from "utils/i18n";
import * as yup from "yup";

const _fileId = "import-production-plan-by-date";

const validateSchema = yup.object().shape({});
const ImportDocumentByPlan = (props: { open: boolean; onClose(): void }) => {
  const dispatch = useAppDispatch();
  const { open, onClose } = props;
  const fileRef = React.useRef<any>();
  const action = useAppSelector((state) => state.ProductionPlanReducer.action);

  const handleFileSelected = (files: FileList) => {
    if (files) {
      const file = files.item(0);
      formik.setFieldValue("file", file);
    }
  };
  useEffect(() => {
    if (!open) {
      formik.resetForm();
    }
  }, [open]);

  const formik = useFormik<{
    fromDate: Moment;
    toDate: Moment;
    file?: File;
  }>({
    initialValues: {
      fromDate: moment(),
      toDate: moment(),
    },
    validationSchema: validateSchema,
    onSubmit: (
      values: {
        fromDate: Moment;
        toDate: Moment;
        file?: File;
      },
      { validateForm }: FormikHelpers<any>
    ) => {
      validateForm().then(() => {
        dispatch(
          ProductionPlanActions.importProductionPlan.request({
            file: values.file as File,
            fromDate: TimeHelper.formatMomentToDate(
              values.fromDate,
              "MM-DD-YYYY"
            ),
            toDate: TimeHelper.formatMomentToDate(values.toDate, "MM-DD-YYYY"),
          })
        );
      });
    },
  });

  useEffect(() => {
    if (
      action.includes(ProductionPlanActions.importProductionPlan.successName)
    ) {
      onClose();
    }
  }, [action]);

  const renderFooter = () => {
    return (
      <Footer
        disableConfirm={isUndefined(formik.values.file)}
        onClose={onClose}
        onConfirm={formik.submitForm}
      />
    );
  };

  return (
    <Fragment>
      <FileSection
        ref={fileRef}
        id={_fileId}
        onFileSelected={handleFileSelected}
      />
      <FormikProvider value={formik}>
        <CommonModal
          title={I18nTranslator(translations.receive.importDocumentByPlan)}
          open={open}
          FooterComponent={renderFooter()}
          handleClose={onClose}
        >
          <Grid
            sx={{ width: "100%" }}
            container
            xs={12}
            alignItems="center"
            rowGap={2}
          >
            <Grid container xs={12} item columnSpacing={2}>
              <Grid xs={6} item>
                <FormDatePicker
                  id="fromDate"
                  label={I18nTranslator(translations.fromDate)}
                />
              </Grid>
              <Grid xs={6} item>
                <FormDatePicker
                  id="toDate"
                  label={I18nTranslator(translations.toDate)}
                />
              </Grid>
            </Grid>
            <Grid container xs={12} item columnSpacing={2}>
              <Grid xs={12} item>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <label htmlFor={_fileId}>
                    <Button component={"span"} variant="contained">
                      {I18nTranslator(translations.button.chooseDocument)}
                    </Button>
                  </label>
                  <Typography
                    sx={{
                      marginLeft: "10px",
                      fontWeight: isUndefined(formik.values.file) ? "0" : "500",
                      fontSize: "18px",
                    }}
                  >
                    {isUndefined(formik.values.file)
                      ? I18nTranslator(translations.receive.notFoundDocument)
                      : formik.values.file?.name}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </CommonModal>
      </FormikProvider>
    </Fragment>
  );
};

const Footer = (props: {
  disableConfirm: boolean;
  onConfirm(): void;
  onClose(): void;
}) => {
  const { disableConfirm, onConfirm, onClose } = props;
  const action = useAppSelector((state) => state.ProductionPlanReducer.action);
  return (
    <Stack direction={"row"} spacing={2} justifyContent={"flex-end"}>
      <Button onClick={onClose}>
        {I18nTranslator(translations.button.cancel)}
      </Button>
      <LoadingButton
        loading={action.includes(
          ProductionPlanActions.importProductionPlan.requestName
        )}
        disabled={disableConfirm}
        onClick={onConfirm}
        variant="contained"
      >
        {I18nTranslator(translations.button.importDocs)}
      </LoadingButton>
    </Stack>
  );
};
export default ImportDocumentByPlan;
